function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.9964 14.6362L12.9949 4.31965C12.9734 4.09061 12.7624 3.9172 12.5156 3.9172H10.4553C10.4267 2.19614 8.8886 0.805542 7 0.805542C5.11139 0.805542 3.57333 2.19614 3.54471 3.9172H1.48441C1.23403 3.9172 1.02657 4.09061 1.00511 4.31965L0.00357691 14.6362C0.00357691 14.6428 0.00268268 14.6493 0.00178845 14.6559C0.000894227 14.6624 0 14.669 0 14.6755C0 15.8501 1.1768 16.8055 2.62544 16.8055H11.3745C12.8232 16.8055 14 15.8501 14 14.6755C14 14.6624 14 14.6493 13.9964 14.6362ZM7.0003 1.68891C8.35598 1.68891 9.4612 2.68359 9.48982 3.91713H4.51077C4.53938 2.68359 5.64464 1.68891 7.0003 1.68891Z",
  fill: "white"
});

function SvgCartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgCartIcon;